import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import Moment from 'moment'
import { ImFilePdf } from 'react-icons/im'
import { Form, Modal, Button } from "react-bootstrap"
import { DeleteForeverRounded } from '@mui/icons-material'
import { getTranslation } from 'utils/renderLanguage'

const AchievementForm = props => {

  const [ achievement, setKpi ] = useState({
    achievement_title: '',
    achievement_description: '',
    achievement_document: '',
    achievement_submission_date: Moment().format( 'DD MMM YYYY' ),
    achievement_submission_note: '',
    achievement_status: 'Pending',
    project_id: props.projectDetail.project_id,
  })

  useEffect( () => {
    if( props.selectedAchievement && props.mode === 'update' ){
      setKpi({ 
        ...props.selectedAchievement,
        achievement_document: props.selectedAchievement.achievement_document_file_name ? {
          snapshot_file_name: props.selectedAchievement.achievement_document_file_name
        } : '',
      })
    }
  }, [] )

  const handleSubmit = () => {
    if( props.mode === 'create' )
      props.createNewAchievement( achievement )
    else 
      props.updateAchievement( achievement )
  }

  const onChangeField = ( val, context ) => {
    let temp = _.cloneDeep( achievement )
    temp[ context ] = val
    setKpi( temp )
  }

  const onUploadFile = ( event, context ) => {
    if( event.target.files && event.target.files.length > 0 ) {
      let files = event.target.files
      const file = files[0]
      
      // Check file size (50MB limit)
      const maxSize = 50 * 1024 * 1024
      if( file.size > maxSize ) {
        alert(`File size exceeds 50MB limit. Please upload a smaller file. Current size: ${(file.size / (1024 * 1024)).toFixed(2)}MB`)
        event.target.value = null
        return
      }
      
      Object.keys( event.target.files ).map((key) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          let tmp = {
            snapshot: e.target.result,
            snapshot_file_name: files[key] ? files[key].name : 'achievement_support_document',
          }
          onChangeField( tmp, context )
        }
        reader.readAsDataURL(event.target.files[key])
      })
    }
  }

  return(
    <Modal show={ true } onHide={() => props.setOpen(false)} size="xl" >
      <Modal.Header closeButton>
        <Modal.Title>{ props.title }</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Achievement' ) }</Form.Label>
          <Form.Control
            type={ 'text' }
            placeholder={ getTranslation( props.language, 'Achievement' ) }
            value={ achievement.achievement_title }
            onChange={ e => onChangeField( e.target.value, 'achievement_title' ) }
          />
        </Form.Group>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Description' ) }</Form.Label>
          <Form.Control
            type={ 'text' }
            style={{ minHeight: 200 }}
            placeholder={ getTranslation( props.language, 'Description' ) }
            as="textarea"
            value={ achievement.achievement_description }
            onChange={ e => onChangeField( e.target.value, 'achievement_description' ) }
          />
        </Form.Group>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Submission Date' ) }</Form.Label>
          <Form.Control
            type={ 'text' }
            disabled
            value={ achievement.achievement_submission_date }
          />
        </Form.Group>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Support Document' ) }</Form.Label>
          {
            achievement.achievement_document && (
              <div className='project-detail__detail-cont d-flex align-items-center' style={{ padding: '10px 20px', marginBottom: 10 }}>
                <ImFilePdf style={{ width: 40, height: 40, color: 'red' }}/>
                <div style={{ marginLeft: 10 }}>
                  <label>File Name</label>
                  <p className='m-0' >
                    { achievement.achievement_document.snapshot_file_name }
                  </p>
                </div>
                <button
                  className={ 'btn btn-danger ml-auto' }
                  onClick={ () =>  onChangeField( '', 'achievement_document' ) }
                >
                  <DeleteForeverRounded />
                </button>
              </div>
            )
          }
          {
            !achievement.achievement_document && (
              <Form.Control
                type={ 'file' }
                style={{ height: 'fit-content', fontSize: 18 }}
                accept={ 'application/pdf' }
                onChange={ event => onUploadFile( event, 'achievement_document' ) }
              />
            )
          }
        </Form.Group>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Notes' ) }</Form.Label>
          <Form.Control
            as='textarea'
            type={ 'text' }
            style={{ minHeight: 150 }}
            placeholder={ getTranslation( props.language, 'Notes' ) }
            value={ achievement.achievement_submission_note }
            onChange={ e => onChangeField( e.target.value, 'achievement_submission_note' ) }
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={() => props.setOpen( false ) } >
          { getTranslation( props.language, 'Close' ) }
        </Button>
        <Button
          variant="primary"
          disabled={ !achievement.achievement_title || !achievement.achievement_description } 
          onClick={ handleSubmit } >
          { getTranslation( props.language, 'Submit' ) }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AchievementForm;